




























import jQuery from 'jquery';
export default {
	name: 'Modal',
	props: {
		id: { required: true },
		modalClasses: { default: '' },
		isLarge: { default: false },
		isSmall: { default: false },
		hasHeader: { default: true },
		backdropClose: { default: true },
		backdropCloseConfirm: { default: false },
		backdropCloseConfirmText: { default: 'Are you sure?' },
	},
	data() {
		return {};
	},
	methods: {
		close() {
			this.$emit('close');
		},
		closeBackdrop() {
			if (!this.backdropClose) {
				return false;
			}
			if (this.backdropCloseConfirm && !confirm(this.backdropCloseConfirmText)) {
				return false;
			}
			this.close();
		},
		closeModal() {
			jQuery(`#${this.id}`).modal('hide');
		},
	},
	computed: {
		modalSizeClasses() {
			if (this.isLarge) {
				return 'modal-lg';
			}
			if (this.isSmall) {
				return 'modal-sm';
			}
			return '';
		},
	},
};
